module.exports = __webpack_public_path__ + "static/media/header-background-v2.82cc8c8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/header-background-v2.png
// module id = 325
// module chunks = 0